import gtag from '../analytics/gtag';
import type { Breadcrumb } from '../model/Facets';
import FacetButton from './FacetButton';

export interface SelectedFacetsProps {
    selectedFacets: Breadcrumb[];
    onFacetValueUnselect(query: string): Promise<void> | void;
}

export default function SelectedFacets({ selectedFacets, onFacetValueUnselect }: SelectedFacetsProps) {
    return selectedFacets.map((facet) => (
        <FacetButton
            key={`${facet.facetValueCode}__${facet.facetCode}`}
            title={facet.facetValueName}
            onClick={async () => {
                gtag('event', 'filter_remove', {
                    filter_type: facet.facetName,
                    filter_value: facet.facetValueName,
                });
                await onFacetValueUnselect(facet.removeQuery);
            }}
            selected
        />
    ));
}
